/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import { ecomGateSyncServiceAsync } from './GatesDataActionExtension.g';

/**
 * PostGates Input Action
 */
export class PostGatesInput implements Msdyn365.IActionInput {
    public salesOrders: SalesOrder;
    // TODO: Construct the input needed to run the action
    constructor(data: SalesOrder) {
        this.salesOrders = data;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SZF-POST-GATES`;
    public getCacheObjectType = () => 'SZF-POST-GATES';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPostGatesData {
    IsSuccess?: boolean;
    Message?: string;
    Data?: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createNewGatesInput = (args: Msdyn365.ICreateActionContext, inputData: SalesOrder): Msdyn365.IActionInput => {
    return new PostGatesInput(inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function createGatesDataAction(input: PostGatesInput, ctx: Msdyn365.IActionContext): Promise<IPostGatesData> {

    try {
        const data: SalesOrder = input.salesOrders;
        const EcomGateSyncServiceResponse = await ecomGateSyncServiceAsync({ callerContext: ctx }, data);
        if(EcomGateSyncServiceResponse){
            return {
                IsSuccess: true,
                Message: "Gates API Successfully Call.",
                Data: EcomGateSyncServiceResponse
            }
        }else{
            return { 
                IsSuccess: false,
                Message: "Something went wrong.",
            }
        }
    } catch (error) {
        console.log("🚀 ~ error:", error)
        return { 
            IsSuccess: false,
            Message: "Something went wrong.",
        }
    }
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPostGatesData[]>('/get/example/id/1', 'get');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostGatesData>>createGatesDataAction,
    // TODO: Give your data action a unique id
    id: 'PostGates',
    input: createNewGatesInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
